import React, { Component } from 'react';
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input } from 'reactstrap'
import { connect } from 'react-redux';
import { uploadMonitoringDataRequest, fetchMonitoringListRequest, downlodOldOrOfflineDataUploadTemplateRequest } from "./action";
import Select from 'react-select'
import { toast } from 'react-toastify';
import { Preloading } from '../../../components/UI/Preloader/action';
import { displayErrorMessage } from "./charts/monitoring-util";
import fileSaver from 'file-saver';
import moment from 'moment';



class MonitoringDataUpload extends Component {

    state = { monitoringPeriod: [], selectedOption: undefined, monitoringFile: undefined };


    componentDidMount() {
        this.props.fetchMonitoringListRequest();
    }

    handleChange = selectedOption => {
        this.setState({ selectedOption: selectedOption });
    };

    uploadFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({ monitoringFile: file });
        } else {
            this.setState({ monitoringFile: undefined });
            e.target.value = null;
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload Excel File only !
                </div>
            );
        }
        e.target = null;
    }

    componentDidUpdate(prevProps) {
        if(prevProps.oldOrOfflineDataUploadtemplate !== this.props.oldOrOfflineDataUploadtemplate){
            this.props.Preloading(false);
            if (this.props.oldOrOfflineDataUploadtemplate.status === "SUCCESS") {
                const data = this.props.oldOrOfflineDataUploadtemplate.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"Data_upload_template"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
            } else if (this.props.monitoringCounterpartyData.status === "FAILURE") {
                displayErrorMessage("Please Try again !!");
            }
        }
        if (this.props.monitoringDataUploadResponse !== prevProps.monitoringDataUploadResponse) {
            this.props.Preloading(false);
            if (this.props.monitoringDataUploadResponse.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i ></i>&nbsp; Data Uploaded Successfully !
                    </div>
                );
                this.setState({monitoringFile  :undefined});
            } else {
               
                let message = this.props.monitoringDataUploadResponse.data.message ? this.props.monitoringDataUploadResponse.data.message : this.props.monitoringDataUploadResponse.data;
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{message}
                    </div>
                );
            }
        }

        if (this.props.monitoringList !== prevProps.monitoringList) {
            let monitoringNameOptions = [];
            this.props.monitoringList && this.props.monitoringList.length > 0 &&
                this.props.monitoringList.map(monitoringObj => (
                    monitoringNameOptions = [
                        ...monitoringNameOptions, {
                            value: monitoringObj.id, label: monitoringObj.monitoringName
                        }
                    ]
                ))
            this.setState({ monitoringPeriod: monitoringNameOptions, selectedOption: monitoringNameOptions.length > 0 ? monitoringNameOptions[0] : undefined })
        }
    }

    submitDataToServer = (e) => {
        e.preventDefault();
        this.props.uploadMonitoringDataRequest({
            file: this.state.monitoringFile,
            monitoringId: this.state.selectedOption.value
        })
        this.props.Preloading(true);
    }

    downloadDataUploadTemplate = (e) => {
        e.preventDefault()
        this.props.Preloading(true);
        this.props.downlodOldOrOfflineDataUploadTemplateRequest()
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">Monitoring Data Upload</h4>
                </div>
                <Card>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={6}>Monitoring Name </Label>
                                <Col sm={14}>
                                    <Select
                                        value={this.state.selectedOption}
                                        onChange={this.handleChange}
                                        options={this.state.monitoringPeriod} />
                                </Col>
                            </FormGroup>
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={6}>Select Monitoring Data File </Label>
                                <Col sm={14}>
                                    <Input type="file" name="monitoring-data-file" id="monitoring-data-file" onChange={(e) => this.uploadFile(e)} className="btn   position-relative " style={{ borderColor: "#007bff" }} />
                                </Col>
                            </FormGroup>

                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={14}></Label>
                                <Col sm={6}>
                                    <Button disabled={!this.state.selectedOption || !this.state.monitoringFile} color="primary" onClick={(e) => this.submitDataToServer(e)} > Submit Data </Button>
                                </Col>
                            </FormGroup>
                        </Form>
                        <div >
                       Upload old/offline Monitoring Data - <br/>
                        1 . Please Download template  &nbsp; <Button  color="link" onClick={(e) => this.downloadDataUploadTemplate(e)} > Download Template </Button><br/>
                        2 . Fill data into respective sheet<br/>
                        3 . Select appropriate monitoring<br/>
                        4 . upload filled file to server <br/>
                        </div>
                    </CardBody></Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    monitoringDataUploadResponse: state.monitoringData.monitoringDataUploadResponse,
    monitoringList: state.monitoringData.monitoringList,
    oldOrOfflineDataUploadtemplate : state.monitoringData.oldOrOfflineDataUploadtemplate
})

const mapDispatchToProps = (dispatch) => ({
    uploadMonitoringDataRequest: data => { dispatch(uploadMonitoringDataRequest(data)) },
    Preloading: data => { dispatch(Preloading(data))},
    fetchMonitoringListRequest: (data) => { dispatch(fetchMonitoringListRequest(data)) },
    downlodOldOrOfflineDataUploadTemplateRequest : data => {dispatch(downlodOldOrOfflineDataUploadTemplateRequest(data))}
});


export default connect(mapStateToProps, mapDispatchToProps)(MonitoringDataUpload);